// Map link builders. Universal URLs open the native maps app on phones and the
// web maps on desktop. "dir" variants request turn-by-turn directions from the
// user's current location.
function joinParts(parts) {
    const list = Array.isArray(parts) ? parts : [parts];
    return list.map((p) => (p == null ? "" : String(p).trim())).filter(Boolean).join(", ").trim();
}

export function googleSearchUrl(parts) {
    const q = joinParts(parts);
    return q ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}` : null;
}

export function appleSearchUrl(parts) {
    const q = joinParts(parts);
    return q ? `https://maps.apple.com/?q=${encodeURIComponent(q)}` : null;
}

export function googleDirUrl(parts) {
    const q = joinParts(parts);
    return q ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(q)}` : null;
}

export function appleDirUrl(parts) {
    const q = joinParts(parts);
    return q ? `https://maps.apple.com/?daddr=${encodeURIComponent(q)}` : null;
}

// Backwards-compatible default: a Google Maps search URL.
export const mapsUrl = googleSearchUrl;

// Single best href for a one-tap "open in maps" on the current device:
//  - Android: geo: URI → opens the default map app (or the OS app chooser)
//  - iOS: Apple Maps universal link → opens the Maps app
//  - Desktop / other: Google Maps web search
export function mapsHref(parts) {
    const q = joinParts(parts);
    if (!q) return null;
    const enc = encodeURIComponent(q);
    const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
    if (/Android/i.test(ua)) return `geo:0,0?q=${enc}`;
    if (/iPad|iPhone|iPod/i.test(ua)) return `https://maps.apple.com/?q=${enc}`;
    return `https://www.google.com/maps/search/?api=1&query=${enc}`;
}
